import AccountCircleIcon from "@material-ui/icons/AccountCircle";

export default AccountCircleIcon;
